<template>
    <div>
        <CCol sm="12" class="background-col" style="background-size: cover; color: #fff" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <br /><br />
            <CCard class="mt-2 b-20">
                <div class="text-center p-4">
                    <img style="max-width:200px" src="../assets/img/genie.png" />
                    <h3 class="custom-20px-700 mt-3">
                        What is your wish?
                    </h3>
                    <p class="custom-12px">Let's get started</p>
    
                    <input type="text" placeholder="Type here" class="custom-input-app" v-model="aladdinsays" />
                    <label class="text-black mt-3">Capture here <img style="max-width:20px" src="../assets/img/Scan.png" /></label>
                    <div style="width:100%; margin: 0 auto">
                        <CButton type="button" class="button-border-blue text-white mt-4" block @click="SubmitAladdin()">Continue</CButton>
                    </div>
                </div>
            </CCard>
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgDiscover.png";
import Footerlayout from "../containers/TheBottomCustom.vue";

export default {
    name: "Login",
    components: {

        Footerlayout,
    },

    data() {
        return {
            backgroundUrl,
            aladdinsays: ""

        };
    },
    created() {
        AOS.init();
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GoToPicture() {
            this.$router.push("TakePicture");
        },
        async SubmitAladdin() {
            const requestData = {
                aladdin_says: this.aladdinsays,
            };

            const customApiLink = "https://bytaken.com/ask-genie";

            return this.$API
                .post(customApiLink, requestData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    this.info = response.data;

                    if (response.status === 200) {
                        this.Busy = false;
                        console.log(response.data);
                        this.category = response.data;
                        this.$router.push("FindServices?category=" + this.category);
                    } else {
                        console.log("Error Saving");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },

};
</script>

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}

.background-col {
    height: 100vh;
    /* Set height to 100% of the viewport height */
    background-size: cover;
    color: #fff;
    /* Add any other styles you need */
}

.content-card {
    background: rgba(255, 255, 255, 0.8);
    /* Add a semi-transparent background for better readability */
    padding: 20px;
    /* Add padding to the content */
}
</style>